<template>
  <validation-provider
    v-slot="{ errors, failed }"
    :name="item.name"
    :vid="`item-${item.id}`"
    :rules="validationRules"
  >
    <div
      class="mb-4"
      :class="{'validation-failed':failed}"
    >
      <label
        :for="`item-${item.id}`"
        class="flex items-center"
      >
        <input
          :id="`item-${item.id}`"
          v-model="value"
          type="checkbox"
          :name="`item-${item.id}`"
          :true-value="true"
          :false-value="false"
          class="form-checkbox"
        >
        <div class="ml-2">
          {{ item.name }}
          <span
            v-if="item.meta.required"
            class="text-sm"
          >(Required)</span>
        </div>
      </label>
      <item-errors :errors="errors" />
    </div>
  </validation-provider>
</template>

<script>
import ItemMixin from './item-mixin'
import ItemErrors from './item-errors'

export default {
  components: {
    ItemErrors
  },
  mixins: [
    ItemMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    validationRules () {
      return {
        required: !this.isRequired ? false : { allowFalse: false }
      }
    }
  },
  created () {
    this.value = this.value || false
  }
}
</script>
